require('coalitions/show-charts');
require('coalitions/show-map');
require('stop_video');


(function() {

  var $self = this;
  $self.Coalitions      = $self.Coalitions      || {};
  $self.Coalitions.show = $self.Coalitions.show || {};

  $self.Coalitions.show.init = function(params) {
    // other js stuff could be init'd here
    $self.Coalitions.show.map.init(params);
  };

}).call(CC);

function showTabsContainter() {
  $('html, body').animate({
    scrollTop: ($('#coalition-pills').offset().top)
  },500);
}

$("#coalition-pills ul.nav-pills a").on('click', function() {
  window.location.hash = $(this).attr("href");
  showTabsContainter();
});

$('a[href="' + window.location.hash + '"]').on('click', function() {
  showTabsContainter();
})

if (window.location.hash) {
  document.querySelector('a[href="' + window.location.hash + '"]').click();
}
